import React from "react";
import "./chart-tooltip.scss";

type CustomChartTooltipProps = {
  active?: boolean;
  payload?: any[];
  label?: string;
  title?: string;
  formatTooltip?: (value: number, key: string) => string;
  formatLabel?: (label: string) => string;
};

const CustomChartTooltip: React.FC<CustomChartTooltipProps> = ({
  active,
  payload,
  label,
  formatTooltip,
  formatLabel,
}) => {
  if (!active || !payload || payload.length === 0) {return null;}

  return (
    <div className="chart-tooltip-container">
      <div className="chart-tooltip-label">{formatLabel ? formatLabel(label ?? "") : label}</div>

      {payload?.map((item, index) => {
        const value = item?.value ?? 0;
        const key = item?.dataKey ?? "";
        const row = item?.payload as Record<string, unknown> | undefined;
        const formattedFromRow = (() => {
          if (!row || !key) {
            return undefined;
          }
          const candidates = [row[`${key}Formatted`], row[`${key}FormattedValue`]];
          for (const candidate of candidates) {
            if (typeof candidate === "string" && candidate.trim()) {
              return candidate.trim();
            }
          }
          return undefined;
        })();
        const formatted = formattedFromRow
          ? formattedFromRow
          : formatTooltip
            ? formatTooltip(value, key)
            : `${value}`;

        return (
          <div key={index} className="chart-tooltip-value">
            <span className="chart-tooltip-title">{item.name}:</span>
            <span className="chart-tooltip-number">{formatted}</span>
          </div>
        );
      })}
    </div>
  );
};

export default CustomChartTooltip;